import { throwError } from 'osn-shared';
import { SimplePageType } from '../domain/simple-page';

export type PageTypeStringValue =
  | 'content'
  | 'genre'
  | 'landing'
  | 'marketingDetails'
  | 'redeem'
  | 'redeemGenericIncomplete'
  | 'redeemPartnerIncomplete'
  | 'appLandingMobile'
  | 'appLandingCotv'
  | 'appLandingTablet'
  | 'appLandingAppleAndroidTv'
  | 'collection';

export class PageType {
  public static readonly content = new PageType('content', 'content', false, 'Content');
  public static readonly genre = new PageType('genre', 'genre', false, 'Genre');
  public static readonly collection = new PageType('collection', 'collection', false, 'Collection');
  public static readonly landing = new PageType('landing', 'marketing/landing-page', true, 'Marketing', 'marketing');
  public static readonly marketingDetails = new PageType('marketingDetails', 'marketing/details-page', true, 'Marketing', 'marketing');
  public static readonly appLandingMobile = new PageType(
    'appLandingMobile',
    'marketing/app-landing-mobile',
    true,
    'Marketing',
    'marketing'
  );
  public static readonly appLandingTablet = new PageType(
    'appLandingTablet',
    'marketing/app-landing-tablet',
    true,
    'Marketing',
    'marketing'
  );
  public static readonly appLandingCotv = new PageType('appLandingCotv', 'marketing/app-landing-cotv', true, 'Marketing', 'marketing');
  public static readonly appLandingAppleAndroidTv = new PageType(
    'appLandingAppleAndroidTv',
    'marketing/app-landing-apple-android-tv',
    true,
    'Marketing',
    'marketing'
  );
  public static readonly redeem = new PageType('redeem', 'redeem', false, 'Redeem');
  public static readonly redeemGenericIncomplete = new PageType('redeemGenericIncomplete', 'redeem', false, 'Redeem');
  public static readonly redeemPartnerIncomplete = new PageType('redeemPartnerIncomplete', 'redeem', false, 'Redeem');

  public readonly routePath: string;
  public readonly rootPath: string;

  private constructor(
    public readonly stringValue: PageTypeStringValue,
    routePath: string,
    public readonly isLanding: boolean,
    public readonly domainPageType: SimplePageType,
    rootPath?: string
  ) {
    this.routePath = `/pages/${routePath}`;
    this.rootPath = rootPath ? `/pages/${rootPath}` : this.routePath;
  }

  public static getAll(): PageType[] {
    return [
      this.content,
      this.landing,
      this.genre,
      this.collection,
      this.marketingDetails,
      this.redeem,
      this.redeemGenericIncomplete,
      this.redeemPartnerIncomplete,
      this.appLandingMobile,
      this.appLandingCotv,
      this.appLandingTablet,
      this.appLandingAppleAndroidTv,
    ];
  }

  public static fromStringValue(stringValue: PageTypeStringValue): PageType {
    return this.getAll().find((it) => it.stringValue === stringValue) ?? throwError(`Page type ${stringValue} is not defined`);
  }
}
